@if (item) {
  <div class="vertical-box-item">
    @if (item.image) {
      <div class="image">
        <a [routerLink]="item.urlButton">
          <cx-media [container]="item.image"></cx-media>
        </a>
      </div>
    }
    @if (item.title) {
      @switch (item.titleTag) {
        @case ('H1') {
          <h1
            class="title"
            [style.color]="item.titleColor"
            [style.font-size]="item.titleSize + 'px'"
            [style.font-weight]="item.titleBold === 'true' ? 'bold' : '400'"
            >
            {{item.title}}
          </h1>
        }
        @case ('H2') {
          <h2
            class="title"
            [style.color]="item.titleColor"
            [style.font-size]="item.titleSize + 'px'"
            [style.font-weight]="item.titleBold === 'true' ? 'bold' : '400'"
            >
            {{item.title}}
          </h2>
        }
        @default {
          <div
            class="title"
            [style.color]="item.titleColor"
            [style.font-size]="item.titleSize + 'px'"
            [style.font-weight]="item.titleBold === 'true' ? 'bold' : '400'"
            >
            {{item.title}}
          </div>
        }
      }
    }
    @if (item.text) {
      <p
        class="text"
        [style.color]="item.textColor"
        [style.font-size]="item.textSize + 'px'"
        >
        {{item.text}}
      </p>
    }
    @if (item.urlButton && item.textButton) {
      <div class="button">
        <a [routerLink]="item.urlButton" class="btn btn-sm btn-outline-primary">
          {{item.textButton}}
        </a>
      </div>
    }
  </div>
}
